const countriesList=
 [ {
    "name": "Saudi Arabia",
    "nameAr": "المملكة العربية السعودية",
    "code": "SA",
    "continent": "Asia"
},  {
    "name": "Bahrain",
    "nameAr": "البحرين",
    "code": "BH",
    "continent": "Asia"
},{
    "name": "Egypt",
    "nameAr": "مصر",
    "code": "EG",
    "continent": "Africa"
},
 {
        "name": "United Arab Emirates",
        "nameAr": "الإمارات العربية المتحدة",
        "code": "AE",
        "continent": "Asia"
    },
    {
        "name": "Kuwait",
        "nameAr": "الكويت",
        "code": "KW",
        "continent": "Asia"
    },
    {
        "name": "Qatar",
        "nameAr": "قطر",
        "code": "QA",
        "continent": "Asia"
    },
  
    {
        "name": "Oman",
        "nameAr": "عُمان",
        "code": "OM",
        "continent": "Asia"
    },
    {
        "name": "Syrian Arab Republic",
        "nameAr": "الجمهورية العربية السورية",
        "code": "SY",
        "continent": "Asia"
    },
    {
        "name": "Iraq",
        "nameAr": "العراق",
        "code": "IQ",
        "continent": "Asia"
    },
    {
        "name": "Yemen",
        "nameAr": "اليمن",
        "code": "YE",
        "continent": "Asia"
    },
    {
        "name": "Palestine",
        "nameAr": "فلسطين",
        "code": "PS",
        "continent": "Asia"
    },

    {
        "name": "Afghanistan",
        "nameAr": "أفغانستان",
        "code": "AF",
        "continent": "Asia"
    },
    {
        "name": "Åland Islands",
        "nameAr": "جزر آلاند",
        "code": "AX",
        "continent": "Europe"
    },
    {
        "name": "Albania",
        "nameAr": "ألبانيا",
        "code": "AL",
        "continent": "Europe"
    },
    {
        "name": "Algeria",
        "nameAr": "الجزائر",
        "code": "DZ",
        "continent": "Africa"
    },
    {
        "name": "American Samoa",
        "nameAr": "ساموا الأمريكية",
        "code": "AS",
        "continent": "Oceania"
    },
    {
        "name": "AndorrA",
        "nameAr": "أندورا",
        "code": "AD",
        "continent": "Europe"
    },
    {
        "name": "Angola",
        "nameAr": "أنغولا",
        "code": "AO",
        "continent": "Africa"
    },
    {
        "name": "Anguilla",
        "nameAr": "أنغويلا",
        "code": "AI",
        "continent": "North America"
    },
    {
        "name": "Antarctica",
        "nameAr": "القطب الجنوبي",
        "code": "AQ",
        "continent": "Antarctica"
    },
    {
        "name": "Antigua and Barbuda",
        "nameAr": "أنتيغوا وبربودا",
        "code": "AG",
        "continent": "North America"
    },
    {
        "name": "Argentina",
        "nameAr": "الأرجنتين",
        "code": "AR",
        "continent": "South America"
    },
    {
        "name": "Armenia",
        "nameAr": "أرمينيا",
        "code": "AM",
        "continent": "Asia"
    },
    {
        "name": "Aruba",
        "nameAr": "أروبا",
        "code": "AW",
        "continent": "North America"
    },
    {
        "name": "Australia",
        "nameAr": "أستراليا",
        "code": "AU",
        "continent": "Oceania"
    },
    {
        "name": "Austria",
        "nameAr": "النمسا",
        "code": "AT",
        "continent": "Europe"
    },
    {
        "name": "Azerbaijan",
        "nameAr": "أذربيجان",
        "code": "AZ",
        "continent": "Asia"
    },
    {
        "name": "Bahamas",
        "nameAr": "الباهاما",
        "code": "BS",
        "continent": "North America"
    },
  
    {
        "name": "Bangladesh",
        "nameAr": "بنغلاديش",
        "code": "BD",
        "continent": "Asia"
    },
    {
        "name": "Barbados",
        "nameAr": "بربادوس",
        "code": "BB",
        "continent": "North America"
    },
    {
        "name": "Belarus",
        "nameAr": "بيلاروس",
        "code": "BY",
        "continent": "Europe"
    },
    {
        "name": "Belgium",
        "nameAr": "بلجيكا",
        "code": "BE",
        "continent": "Europe"
    },
    {
        "name": "Belize",
        "nameAr": "بليز",
        "code": "BZ",
        "continent": "North America"
    },
    {
        "name": "Benin",
        "nameAr": "بنين",
        "code": "BJ",
        "continent": "Africa"
    },
    {
        "name": "Bermuda",
        "nameAr": "برمودا",
        "code": "BM",
        "continent": "North America"
    },
    {
        "name": "Bhutan",
        "nameAr": "بوتان",
        "code": "BT",
        "continent": "Asia"
    },
    {
        "name": "Bolivia",
        "nameAr": "بوليفيا",
        "code": "BO",
        "continent": "South America"
    },
    {
        "name": "Bosnia and Herzegovina",
        "nameAr": "البوسنة والهرسك",
        "code": "BA",
        "continent": "Europe"
    },
    {
        "name": "Botswana",
        "nameAr": "بوتسوانا",
        "code": "BW",
        "continent": "Africa"
    },
    {
        "name": "Bouvet Island",
        "nameAr": "جزيرة بوفيه",
        "code": "BV",
        "continent": "Antarctica"
    },
    {
        "name": "Brazil",
        "nameAr": "البرازيل",
        "code": "BR",
        "continent": "South America"
    },
    {
        "name": "British Indian Ocean Territory",
        "nameAr": "إقليم المحيط الهندي البريطاني",
        "code": "IO",
        "continent": "Asia"
    },
    {
        "name": "Brunei Darussalam",
        "nameAr": "بروناي دار السلام",
        "code": "BN",
        "continent": "Asia"
    },
    {
        "name": "Bulgaria",
        "nameAr": "بلغاريا",
        "code": "BG",
        "continent": "Europe"
    },
    {
        "name": "Burkina Faso",
        "nameAr": "بوركينا فاسو",
        "code": "BF",
        "continent": "Africa"
    },
    {
        "name": "Burundi",
        "nameAr": "بوروندي",
        "code": "BI",
        "continent": "Africa"
    },
    {
        "name": "Cambodia",
        "nameAr": "كمبوديا",
        "code": "KH",
        "continent": "Asia"
    },
    {
        "name": "Cameroon",
        "nameAr": "الكاميرون",
        "code": "CM",
        "continent": "Africa"
    },
    {
        "name": "Canada",
        "nameAr": "كندا",
        "code": "CA",
        "continent": "North America"
    },
    {
        "name": "Cape Verde",
        "nameAr": "الرأس الأخضر",
        "code": "CV",
        "continent": "Africa"
    },
    {
        "name": "Cayman Islands",
        "nameAr": "جزر كايمان",
        "code": "KY",
        "continent": "North America"
    },
    {
        "name": "Central African Republic",
        "nameAr": "جمهورية أفريقيا الوسطى",
        "code": "CF",
        "continent": "Africa"
    },
    {
        "name": "Chad",
        "nameAr": "تشاد",
        "code": "TD",
        "continent": "Africa"
    },
    {
        "name": "Chile",
        "nameAr": "شيلي",
        "code": "CL",
        "continent": "South America"
    },
    {
        "name": "China",
        "nameAr": "الصين",
        "code": "CN",
        "continent": "Asia"
    },
    {
        "name": "Christmas Island",
        "nameAr": "جزيرة الكريسماس",
        "code": "CX",
        "continent": "Asia"
    },
    {
        "name": "Cocos (Keeling) Islands",
        "nameAr": "جزر كوكوس (كيلينغ)",
        "code": "CC",
        "continent": "Asia"
    },
    {
        "name": "Colombia",
        "nameAr": "كولومبيا",
        "code": "CO",
        "continent": "South America"
    },
    {
        "name": "Comoros",
        "nameAr": "جزر القمر",
        "code": "KM",
        "continent": "Africa"
    },
    {
        "name": "Congo",
        "nameAr": "الكونغو",
        "code": "CG",
        "continent": "Africa"
    },
    {
        "name": "Congo, The Democratic Republic of the",
        "nameAr": "جمهورية الكونغو الديمقراطية",
        "code": "CD",
        "continent": "Africa"
    },
    {
        "name": "Cook Islands",
        "nameAr": "جزر كوك",
        "code": "CK",
        "continent": "Oceania"
    },
    {
        "name": "Costa Rica",
        "nameAr": "كوستاريكا",
        "code": "CR",
        "continent": "North America"
    },
    {
        "name": "Cote D'Ivoire",
        "nameAr": "ساحل العاج",
        "code": "CI",
        "continent": "Africa"
    },
    {
        "name": "Croatia",
        "nameAr": "كرواتيا",
        "code": "HR",
        "continent": "Europe"
    },
    {
        "name": "Cuba",
        "nameAr": "كوبا",
        "code": "CU",
        "continent": "North America"
    },
    {
        "name": "Cyprus",
        "nameAr": "قبرص",
        "code": "CY",
        "continent": "Europe"
    },
    {
        "name": "Czech Republic",
        "nameAr": "الجمهورية التشيكية",
        "code": "CZ",
        "continent": "Europe"
    },
    {
        "name": "Denmark",
        "nameAr": "الدانمارك",
        "code": "DK",
        "continent": "Europe"
    },
    {
        "name": "Djibouti",
        "nameAr": "جيبوتي",
        "code": "DJ",
        "continent": "Africa"
    },
    {
        "name": "Dominica",
        "nameAr": "دومينيكا",
        "code": "DM",
        "continent": "North America"
    },
    {
        "name": "Dominican Republic",
        "nameAr": "جمهورية الدومينيكان",
        "code": "DO",
        "continent": "North America"
    },
    {
        "name": "Ecuador",
        "nameAr": "الإكوادور",
        "code": "EC",
        "continent": "South America"
    },
    
    {
        "name": "El Salvador",
        "nameAr": "السلفادور",
        "code": "SV",
        "continent": "North America"
    },
    {
        "name": "Equatorial Guinea",
        "nameAr": "غينيا الاستوائية",
        "code": "GQ",
        "continent": "Africa"
    },
    {
        "name": "Eritrea",
        "nameAr": "إريتريا",
        "code": "ER",
        "continent": "Africa"
    },
    {
        "name": "Estonia",
        "nameAr": "إستونيا",
        "code": "EE",
        "continent": "Europe"
    },
    {
        "name": "Ethiopia",
        "nameAr": "إثيوبيا",
        "code": "ET",
        "continent": "Africa"
    },
    {
        "name": "Falkland Islands (Malvinas)",
        "nameAr": "جزر فوكلاند (مالفيناس)",
        "code": "FK",
        "continent": "South America"
    },
    {
        "name": "Faroe Islands",
        "nameAr": "جزر فارو",
        "code": "FO",
        "continent": "Europe"
    },
    {
        "name": "Fiji",
        "nameAr": "فيجي",
        "code": "FJ",
        "continent": "Oceania"
    },
    {
        "name": "Finland",
        "nameAr": "فنلندا",
        "code": "FI",
        "continent": "Europe"
    },
    {
        "name": "France",
        "nameAr": "فرنسا",
        "code": "FR",
        "continent": "Europe"
    },
    {
        "name": "French Guiana",
        "nameAr": "غويانا الفرنسية",
        "code": "GF",
        "continent": "South America"
    },
    {
        "name": "French Polynesia",
        "nameAr": "بولينيزيا الفرنسية",
        "code": "PF",
        "continent": "Oceania"
    },
    {
        "name": "French Southern Territories",
        "nameAr": "الأقاليم الجنوبية لفرنسا",
        "code": "TF",
        "continent": "Antarctica"
    },
    {
        "name": "Gabon",
        "nameAr": "الغابون",
        "code": "GA",
        "continent": "Africa"
    },
    {
        "name": "Gambia",
        "nameAr": "غامبيا",
        "code": "GM",
        "continent": "Africa"
    },
    {
        "name": "Georgia",
        "nameAr": "جورجيا",
        "code": "GE",
        "continent": "Asia"
    },
    {
        "name": "Germany",
        "nameAr": "ألمانيا",
        "code": "DE",
        "continent": "Europe"
    },
    {
        "name": "Ghana",
        "nameAr": "غانا",
        "code": "GH",
        "continent": "Africa"
    },
    {
        "name": "Gibraltar",
        "nameAr": "جبل طارق",
        "code": "GI",
        "continent": "Europe"
    },
    {
        "name": "Greece",
        "nameAr": "اليونان",
        "code": "GR",
        "continent": "Europe"
    },
    {
        "name": "Greenland",
        "nameAr": "جرينلاند",
        "code": "GL",
        "continent": "North America"
    },
    {
        "name": "Grenada",
        "nameAr": "غرينادا",
        "code": "GD",
        "continent": "North America"
    },
    {
        "name": "Guadeloupe",
        "nameAr": "جوادلوب",
        "code": "GP",
        "continent": "North America"
    },
    {
        "name": "Guam",
        "nameAr": "غوام",
        "code": "GU",
        "continent": "Oceania"
    },
    {
        "name": "Guatemala",
        "nameAr": "غواتيمالا",
        "code": "GT",
        "continent": "North America"
    },
    {
        "name": "Guernsey",
        "nameAr": "غيرنسي",
        "code": "GG",
        "continent": "Europe"
    },
    {
        "name": "Guinea",
        "nameAr": "غينيا",
        "code": "GN",
        "continent": "Africa"
    },
    {
        "name": "Guinea-Bissau",
        "nameAr": "غينيا بيساو",
        "code": "GW",
        "continent": "Africa"
    },
    {
        "name": "Guyana",
        "nameAr": "غيانا",
        "code": "GY",
        "continent": "South America"
    },
    {
        "name": "Haiti",
        "nameAr": "هايتي",
        "code": "HT",
        "continent": "North America"
    },
    {
        "name": "Heard Island and Mcdonald Islands",
        "nameAr": "جزيرة هيرد وجزر ماكدونالد",
        "code": "HM",
        "continent": "Antarctica"
    },
    {
        "name": "Holy See (Vatican City State)",
        "nameAr": "الكرسي الرسولي (دولة الفاتيكان)",
        "code": "VA",
        "continent": "Europe"
    },
    {
        "name": "Honduras",
        "nameAr": "هندوراس",
        "code": "HN",
        "continent": "North America"
    },
    {
        "name": "Hong Kong",
        "nameAr": "هونغ كونغ",
        "code": "HK",
        "continent": "Asia"
    },
    {
        "name": "Hungary",
        "nameAr": "هنغاريا",
        "code": "HU",
        "continent": "Europe"
    },
    {
        "name": "Iceland",
        "nameAr": "أيسلندا",
        "code": "IS",
        "continent": "Europe"
    },
    {
        "name": "India",
        "nameAr": "الهند",
        "code": "IN",
        "continent": "Asia"
    },
    {
        "name": "Indonesia",
        "nameAr": "إندونيسيا",
        "code": "ID",
        "continent": "Asia"
    },
    {
        "name": "Iran, Islamic Republic Of",
        "nameAr": "جمهورية إيران الإسلامية",
        "code": "IR",
        "continent": "Asia"
    },
  
    {
        "name": "Ireland",
        "nameAr": "أيرلندا",
        "code": "IE",
        "continent": "Europe"
    },
    {
        "name": "Isle of Man",
        "nameAr": "جزيرة مان",
        "code": "IM",
        "continent": "Europe"
    },
    {
        "name": "Italy",
        "nameAr": "إيطاليا",
        "code": "IT",
        "continent": "Europe"
    },
    {
        "name": "Jamaica",
        "nameAr": "جامايكا",
        "code": "JM",
        "continent": "North America"
    },
    {
        "name": "Japan",
        "nameAr": "اليابان",
        "code": "JP",
        "continent": "Asia"
    },
    {
        "name": "Jersey",
        "nameAr": "جيرسي",
        "code": "JE",
        "continent": "Europe"
    },
    {
        "name": "Jordan",
        "nameAr": "الأردن",
        "code": "JO",
        "continent": "Asia"
    },
    {
        "name": "Kazakhstan",
        "nameAr": "كازاخستان",
        "code": "KZ",
        "continent": "Asia"
    },
    {
        "name": "Kenya",
        "nameAr": "كينيا",
        "code": "KE",
        "continent": "Africa"
    },
    {
        "name": "Kiribati",
        "nameAr": "كيريباتي",
        "code": "KI",
        "continent": "Oceania"
    },
    {
        "name": "Korea, Democratic People\"S Republic of",
        "nameAr": "كوريا، جمهورية الشعب الديمقراطية",
        "code": "KP",
        "continent": "Asia"
    },
    {
        "name": "Korea, Republic of",
        "nameAr": "كوريا، جمهورية",
        "code": "KR",
        "continent": "Asia"
    },
  
    {
        "name": "Kyrgyzstan",
        "nameAr": "قيرغيزستان",
        "code": "KG",
        "continent": "Asia"
    },
    {
        "name": "Lao People\"S Democratic Republic",
        "nameAr": "جمهورية لاو الديمقراطية الشعبية",
        "code": "LA",
        "continent": "Asia"
    },
    {
        "name": "Latvia",
        "nameAr": "لاتفيا",
        "code": "LV",
        "continent": "Europe"
    },
    {
        "name": "Lebanon",
        "nameAr": "لبنان",
        "code": "LB",
        "continent": "Asia"
    },
    {
        "name": "Lesotho",
        "nameAr": "ليسوتو",
        "code": "LS",
        "continent": "Africa"
    },
    {
        "name": "Liberia",
        "nameAr": "ليبيريا",
        "code": "LR",
        "continent": "Africa"
    },
    {
        "name": "Libyan Arab Jamahiriya",
        "nameAr": "الجماهيرية العربية الليبية",
        "code": "LY",
        "continent": "Africa"
    },
    {
        "name": "Liechtenstein",
        "nameAr": "ليختنشتاين",
        "code": "LI",
        "continent": "Europe"
    },
    {
        "name": "Lithuania",
        "nameAr": "ليتوانيا",
        "code": "LT",
        "continent": "Europe"
    },
    {
        "name": "Luxembourg",
        "nameAr": "لوكسمبورغ",
        "code": "LU",
        "continent": "Europe"
    },
    {
        "name": "Macao",
        "nameAr": "ماكاو",
        "code": "MO",
        "continent": "Asia"
    },
    {
        "name": "Macedonia, The Former Yugoslav Republic of",
        "nameAr": "مقدونيا، جمهورية يوغوسلافيا السابقة",
        "code": "MK",
        "continent": "Europe"
    },
    {
        "name": "Madagascar",
        "nameAr": "مدغشقر",
        "code": "MG",
        "continent": "Africa"
    },
    {
        "name": "Malawi",
        "nameAr": "ملاوي",
        "code": "MW",
        "continent": "Africa"
    },
    {
        "name": "Malaysia",
        "nameAr": "ماليزيا",
        "code": "MY",
        "continent": "Asia"
    },
    {
        "name": "Maldives",
        "nameAr": "المالديف",
        "code": "MV",
        "continent": "Asia"
    },
    {
        "name": "Mali",
        "nameAr": "مالي",
        "code": "ML",
        "continent": "Africa"
    },
    {
        "name": "Malta",
        "nameAr": "مالطا",
        "code": "MT",
        "continent": "Europe"
    },
    {
        "name": "Marshall Islands",
        "nameAr": "جزر مارشال",
        "code": "MH",
        "continent": "Oceania"
    },
    {
        "name": "Martinique",
        "nameAr": "مارتينيك",
        "code": "MQ",
        "continent": "North America"
    },
    {
        "name": "Mauritania",
        "nameAr": "موريتانيا",
        "code": "MR",
        "continent": "Africa"
    },
    {
        "name": "Mauritius",
        "nameAr": "موريشيوس",
        "code": "MU",
        "continent": "Africa"
    },
    {
        "name": "Mayotte",
        "nameAr": "مايوت",
        "code": "YT",
        "continent": "Africa"
    },
    {
        "name": "Mexico",
        "nameAr": "المكسيك",
        "code": "MX",
        "continent": "North America"
    },
    {
        "name": "Micronesia, Federated States of",
        "nameAr": "ميكرونيزيا، ولايات موحدة",
        "code": "FM",
        "continent": "Oceania"
    },
    {
        "name": "Moldova, Republic of",
        "nameAr": "مولدوفا، جمهورية",
        "code": "MD",
        "continent": "Europe"
    },
    {
        "name": "Monaco",
        "nameAr": "موناكو",
        "code": "MC",
        "continent": "Europe"
    },
    {
        "name": "Mongolia",
        "nameAr": "منغوليا",
        "code": "MN",
        "continent": "Asia"
    },
    {
        "name": "Montserrat",
        "nameAr": "مونتسيرات",
        "code": "MS",
        "continent": "North America"
    },
    {
        "name": "Morocco",
        "nameAr": "المغرب",
        "code": "MA",
        "continent": "Africa"
    },
    {
        "name": "Mozambique",
        "nameAr": "موزمبيق",
        "code": "MZ",
        "continent": "Africa"
    },
    {
        "name": "Myanmar",
        "nameAr": "ميانمار",
        "code": "MM",
        "continent": "Asia"
    },
    {
        "name": "Namibia",
        "nameAr": "ناميبيا",
        "code": "NA",
        "continent": "Africa"
    },
    {
        "name": "Nauru",
        "nameAr": "ناورو",
        "code": "NR",
        "continent": "Oceania"
    },
    {
        "name": "Nepal",
        "nameAr": "نيبال",
        "code": "NP",
        "continent": "Asia"
    },
    {
        "name": "Netherlands",
        "nameAr": "هولندا",
        "code": "NL",
        "continent": "Europe"
    },
    {
        "name": "Netherlands Antilles",
        "nameAr": "جزر الأنتيل الهولندية",
        "code": "AN",
        "continent": "North America"
    },
    {
        "name": "New Caledonia",
        "nameAr": "كاليدونيا الجديدة",
        "code": "NC",
        "continent": "Oceania"
    },
    {
        "name": "New Zealand",
        "nameAr": "نيوزيلندا",
        "code": "NZ",
        "continent": "Oceania"
    },
    {
        "name": "Nicaragua",
        "nameAr": "نيكاراغوا",
        "code": "NI",
        "continent": "North America"
    },
    {
        "name": "Niger",
        "nameAr": "النيجر",
        "code": "NE",
        "continent": "Africa"
    },
    {
        "name": "Nigeria",
        "nameAr": "نيجيريا",
        "code": "NG",
        "continent": "Africa"
    },
    {
        "name": "Niue",
        "nameAr": "نيوي",
        "code": "NU",
        "continent": "Oceania"
    },
    {
        "name": "Norfolk Island",
        "nameAr": "جزيرة نورفولك",
        "code": "NF",
        "continent": "Oceania"
    },
    {
        "name": "Northern Mariana Islands",
        "nameAr": "جزر ماريانا الشمالية",
        "code": "MP",
        "continent": "Oceania"
    },
    {
        "name": "Norway",
        "nameAr": "النرويج",
        "code": "NO",
        "continent": "Europe"
    },
  
    {
        "name": "Pakistan",
        "nameAr": "باكستان",
        "code": "PK",
        "continent": "Asia"
    },
    {
        "name": "Palau",
        "nameAr": "بالاو",
        "code": "PW",
        "continent": "Oceania"
    },
    {
        "name": "Palestinian Territory, Occupied",
        "nameAr": "الأراضي الفلسطينية المحتلة",
        "code": "PS",
        "continent": "Asia"
    },
    {
        "name": "Panama",
        "nameAr": "بنما",
        "code": "PA",
        "continent": "North America"
    },
    {
        "name": "Papua New Guinea",
        "nameAr": "بابوا غينيا الجديدة",
        "code": "PG",
        "continent": "Oceania"
    },
    {
        "name": "Paraguay",
        "nameAr": "باراغواي",
        "code": "PY",
        "continent": "South America"
    },
    {
        "name": "Peru",
        "nameAr": "بيرو",
        "code": "PE",
        "continent": "South America"
    },
    {
        "name": "Philippines",
        "nameAr": "الفلبين",
        "code": "PH",
        "continent": "Asia"
    },
    {
        "name": "Pitcairn",
        "nameAr": "بيتكيرن",
        "code": "PN",
        "continent": "Oceania"
    },
    {
        "name": "Poland",
        "nameAr": "بولندا",
        "code": "PL",
        "continent": "Europe"
    },
    {
        "name": "Portugal",
        "nameAr": "البرتغال",
        "code": "PT",
        "continent": "Europe"
    },
    {
        "name": "Puerto Rico",
        "nameAr": "بورتوريكو",
        "code": "PR",
        "continent": "North America"
    },
  
    {
        "name": "Reunion",
        "nameAr": "لا ريونيون",
        "code": "RE",
        "continent": "Africa"
    },
    {
        "name": "Romania",
        "nameAr": "رومانيا",
        "code": "RO",
        "continent": "Europe"
    },
    {
        "name": "Russian Federation",
        "nameAr": "الاتحاد الروسي",
        "code": "RU",
        "continent": "Europe"
    },
    {
        "name": "RWANDA",
        "nameAr": "رواندا",
        "code": "RW",
        "continent": "Africa"
    },
    {
        "name": "Saint Helena",
        "nameAr": "سانت هيلانة",
        "code": "SH",
        "continent": "Africa"
    },
    {
        "name": "Saint Kitts and Nevis",
        "nameAr": "سانت كيتس ونيفيس",
        "code": "KN",
        "continent": "North America"
    },
    {
        "name": "Saint Lucia",
        "nameAr": "سانت لوسيا",
        "code": "LC",
        "continent": "North America"
    },
    {
        "name": "Saint Pierre and Miquelon",
        "nameAr": "سانت بيير وميكلون",
        "code": "PM",
        "continent": "North America"
    },
    {
        "name": "Saint Vincent and the Grenadines",
        "nameAr": "سانت فنسنت والغرينادين",
        "code": "VC",
        "continent": "North America"
    },
    {
        "name": "Samoa",
        "nameAr": "ساموا",
        "code": "WS",
        "continent": "Oceania"
    },
    {
        "name": "San Marino",
        "nameAr": "سان مارينو",
        "code": "SM",
        "continent": "Europe"
    },
    {
        "name": "Sao Tome and Principe",
        "nameAr": "ساو تومي وبرينسيبي",
        "code": "ST",
        "continent": "Africa"
    },
   
    {
        "name": "Senegal",
        "nameAr": "السنغال",
        "code": "SN",
        "continent": "Africa"
    },
    {
        "name": "Serbia and Montenegro",
        "nameAr": "صربيا والجبل الأسود",
        "code": "CS",
        "continent": "Europe"
    },
    {
        "name": "Seychelles",
        "nameAr": "سيشيل",
        "code": "SC",
        "continent": "Africa"
    },
    {
        "name": "Sierra Leone",
        "nameAr": "سيراليون",
        "code": "SL",
        "continent": "Africa"
    },
    {
        "name": "Singapore",
        "nameAr": "سنغافورة",
        "code": "SG",
        "continent": "Asia"
    },
    {
        "name": "Slovakia",
        "nameAr": "سلوفاكيا",
        "code": "SK",
        "continent": "Europe"
    },
    {
        "name": "Slovenia",
        "nameAr": "سلوفينيا",
        "code": "SI",
        "continent": "Europe"
    },
    {
        "name": "Solomon Islands",
        "nameAr": "جزر سليمان",
        "code": "SB",
        "continent": "Oceania"
    },
    {
        "name": "Somalia",
        "nameAr": "الصومال",
        "code": "SO",
        "continent": "Africa"
    },
    {
        "name": "South Africa",
        "nameAr": "جنوب أفريقيا",
        "code": "ZA",
        "continent": "Africa"
    },
    {
        "name": "South Georgia and the South Sandwich Islands",
        "nameAr": "جورجيا الجنوبية وجزر ساندويتش الجنوبية",
        "code": "GS",
        "continent": "Antarctica"
    },
    {
        "name": "Spain",
        "nameAr": "إسبانيا",
        "code": "ES",
        "continent": "Europe"
    },
    {
        "name": "Sri Lanka",
        "nameAr": "سريلانكا",
        "code": "LK",
        "continent": "Asia"
    },
    {
        "name": "Sudan",
        "nameAr": "السودان",
        "code": "SD",
        "continent": "Africa"
    },
    {
        "name": "Suriname",
        "nameAr": "سورينام",
        "code": "SR",
        "continent": "South America"
    },
    {
        "name": "Svalbard and Jan Mayen",
        "nameAr": "سفالبارد ويان ماين",
        "code": "SJ",
        "continent": "Europe"
    },
    {
        "name": "Swaziland",
        "nameAr": "سوازيلاند",
        "code": "SZ",
        "continent": "Africa"
    },
    {
        "name": "Sweden",
        "nameAr": "السويد",
        "code": "SE",
        "continent": "Europe"
    },
    {
        "name": "Switzerland",
        "nameAr": "سويسرا",
        "code": "CH",
        "continent": "Europe"
    },
   
    {
        "name": "Taiwan, Province of China",
        "nameAr": "تايوان، إقليم الصين",
        "code": "TW",
        "continent": "Asia"
    },
    {
        "name": "Tajikistan",
        "nameAr": "طاجيكستان",
        "code": "TJ",
        "continent": "Asia"
    },
    {
        "name": "Tanzania, United Republic of",
        "nameAr": "تنزانيا، جمهورية متحدة",
        "code": "TZ",
        "continent": "Africa"
    },
    {
        "name": "Thailand",
        "nameAr": "تايلاند",
        "code": "TH",
        "continent": "Asia"
    },
    {
        "name": "Timor-Leste",
        "nameAr": "تيمور الشرقية",
        "code": "TL",
        "continent": "Asia"
    },
    {
        "name": "Togo",
        "nameAr": "توغو",
        "code": "TG",
        "continent": "Africa"
    },
    {
        "name": "Tokelau",
        "nameAr": "توكيلاو",
        "code": "TK",
        "continent": "Oceania"
    },
    {
        "name": "Tonga",
        "nameAr": "تونغا",
        "code": "TO",
        "continent": "Oceania"
    },
    {
        "name": "Trinidad and Tobago",
        "nameAr": "ترينيداد وتوباغو",
        "code": "TT",
        "continent": "North America"
    },
    {
        "name": "Tunisia",
        "nameAr": "تونس",
        "code": "TN",
        "continent": "Africa"
    },
    {
        "name": "Turkey",
        "nameAr": "تركيا",
        "code": "TR",
        "continent": "Asia"
    },
    {
        "name": "Turkmenistan",
        "nameAr": "تركمانستان",
        "code": "TM",
        "continent": "Asia"
    },
    {
        "name": "Turks and Caicos Islands",
        "nameAr": "جزر تركس وكايكوس",
        "code": "TC",
        "continent": "North America"
    },
    {
        "name": "Tuvalu",
        "nameAr": "توفالو",
        "code": "TV",
        "continent": "Oceania"
    },
    {
        "name": "Uganda",
        "nameAr": "أوغندا",
        "code": "UG",
        "continent": "Africa"
    },
    {
        "name": "Ukraine",
        "nameAr": "أوكرانيا",
        "code": "UA",
        "continent": "Europe"
    },
   
    {
        "name": "United Kingdom",
        "nameAr": "المملكة المتحدة",
        "code": "GB",
        "continent": "Europe"
    },
    {
        "name": "United States",
        "nameAr": "الولايات المتحدة",
        "code": "US",
        "continent": "North America"
    },
    {
        "name": "United States Minor Outlying Islands",
        "nameAr": "الجزر البعيدة الصغيرة للولايات المتحدة",
        "code": "UM",
        "continent": "Oceania"
    },
    {
        "name": "Uruguay",
        "nameAr": "أوروغواي",
        "code": "UY",
        "continent": "South America"
    },
    {
        "name": "Uzbekistan",
        "nameAr": "أوزبكستان",
        "code": "UZ",
        "continent": "Asia"
    },
    {
        "name": "Vanuatu",
        "nameAr": "فانواتو",
        "code": "VU",
        "continent": "Oceania"
    },
    {
        "name": "Venezuela",
        "nameAr": "فنزويلا",
        "code": "VE",
        "continent": "South America"
    },
    {
        "name": "Viet Nam",
        "nameAr": "فيتنام",
        "code": "VN",
        "continent": "Asia"
    },
    {
        "name": "Virgin Islands, British",
        "nameAr": "جزر العذراء البريطانية",
        "code": "VG",
        "continent": "North America"
    },
    {
        "name": "Virgin Islands, U.S.",
        "nameAr": "جزر العذراء الأمريكية",
        "code": "VI",
        "continent": "North America"
    },
    {
        "name": "Wallis and Futuna",
        "nameAr": "واليس وفوتونا",
        "code": "WF",
        "continent": "Oceania"
    },
    {
        "name": "Western Sahara",
        "nameAr": "الصحراء الغربية",
        "code": "EH",
        "continent": "Africa"
    },
  
    {
        "name": "Zambia",
        "nameAr": "زامبيا",
        "code": "ZM",
        "continent": "Africa"
    },
    {
        "name": "Zimbabwe",
        "nameAr": "زيمبابوي",
        "code": "ZW",
        "continent": "Africa"
    }
]

export default countriesList